import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { SettingsService } from '../../../core/settings/settings.service';

@Component({
  selector: 'app-support-expired',
  templateUrl: './support-expired.component.html',
  styleUrls: ['./support-expired.component.scss']
})
export default class SupportExpiredComponent {

  constructor(
    public settings: SettingsService,
    private translation: TranslateService,
    private titleService: Title
  ) {
    this.titleService.setTitle('Support expired - InviteDesk');
  }

  public close() {
    window.close();
  }
}
